import React, { useEffect, useState } from "react";
import { BookMarked, Award, Library, ClipboardList } from "lucide-react";
import { IMAGES } from "@/lib/constants";
import { PageBanner } from "@/components/PageBanner";
import { api } from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const TABS = [
  { key: "Homework", icon: ClipboardList, empty: "No homework posted yet." },
  { key: "Results", icon: Award, empty: "Results will be published here after examinations." },
  { key: "Study Materials", icon: Library, empty: "Study materials will be shared here." },
];

export default function StudentCorner() {
  const [resources, setResources] = useState([]);
  useEffect(() => { api.getStudentResources().then((r) => setResources(r.data)).catch(() => {}); }, []);

  const byCat = (c) => resources.filter((r) => r.category === c);

  return (
    <div>
      <PageBanner title="Student Corner" subtitle="Homework, results and study materials — all in one place." image={IMAGES.students} />
      <section className="max-w-5xl mx-auto px-6 py-20">
        <div className="bg-gold/15 border border-gold/40 rounded-2xl p-5 mb-8 flex items-center gap-3">
          <BookMarked className="h-6 w-6 text-gold" />
          <p className="text-sm text-navy"><b>Attendance tracking</b> is coming soon! Parents will be able to view daily attendance here.</p>
        </div>

        <Tabs defaultValue="Homework">
          <TabsList className="w-full flex flex-wrap h-auto bg-slate-100 p-1 rounded-xl">
            {TABS.map((t) => (
              <TabsTrigger key={t.key} value={t.key} data-testid={`sc-tab-${t.key.toLowerCase().replace(/\s/g, "-")}`}
                className="flex-1 data-[state=active]:bg-white data-[state=active]:text-brandred font-semibold gap-1.5">
                <t.icon className="h-4 w-4" /> {t.key}
              </TabsTrigger>
            ))}
          </TabsList>
          {TABS.map((t) => (
            <TabsContent key={t.key} value={t.key} className="mt-6 space-y-3">
              {byCat(t.key).length === 0 && <p className="text-slate-500 text-center py-10">{t.empty}</p>}
              {byCat(t.key).map((r) => (
                <div key={r.id} className="bg-white rounded-2xl p-5 border border-slate-200 shadow-sm">
                  <div className="flex items-center justify-between flex-wrap gap-2">
                    <h4 className="font-head font-bold text-navy">{r.title}</h4>
                    <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-navy/5 text-navy">{r.target_class}</span>
                  </div>
                  {r.content && <p className="text-sm text-slate-600 mt-2 leading-relaxed">{r.content}</p>}
                  <div className="flex items-center gap-3 mt-2">
                    <span className="text-xs text-slate-400">{r.date}</span>
                    {r.url && <a href={r.url} target="_blank" rel="noopener noreferrer" className="text-xs font-bold text-brandred hover:underline">Open Resource →</a>}
                  </div>
                </div>
              ))}
            </TabsContent>
          ))}
        </Tabs>
      </section>
    </div>
  );
}
